import { Environment } from '../common';
import { isObject } from '../utils';

export interface EnvConfig {
  cmsUrl: string;
  instantSearchUrl: string;
  offersUrl: string;
  airBoundsUrl: string;
  airCalendarUrl: string;
  locationsUrl: string;
  recommendationUrl: string;
  timeGeoUrl: string;
  bookingUrl: string;
  configUrl: string;
  amApiUrl: string;
  amDeeplinkUrl: string;
}

const testConfig: EnvConfig = Object.freeze({
  cmsUrl: 'https://cms-preprod.finnair.com',
  instantSearchUrl: 'https://api-dev.finnair.com/d/fcom/instantsearch-test/current/api/instantsearch',
  offersUrl: 'https://api-dev.finnair.com/d/fcom/offers-test/current/api/offerList',
  airBoundsUrl: 'https://api-dev.finnair.com/d/fcom/offers-test/current/api/airBounds',
  airCalendarUrl: 'https://api-dev.finnair.com/d/fcom/offers-test/current/api/airCalendar',
  locationsUrl: 'https://api-dev.finnair.com/d/fcom/locations-test/current',
  recommendationUrl: 'https://api-preprod.finnair.com/c/recommendation/preprod',
  timeGeoUrl: 'https://api.finnair.com/timegeo',
  bookingUrl: 'https://www-master.finnair.com',
  configUrl: 'https://api-dev.finnair.com/d/fcom/config-test/current',
  amApiUrl: 'https://green.ftest.aurinkomatkat.fi/api/fcom-locations/v1',
  amDeeplinkUrl: 'https://green.ftest.aurinkomatkat.fi/matkahaku/finnair',
  // amDeeplinkUrl: 'https://am.fdev/matkahaku/finnair', // for running Fores locally
});

const preprodConfig: EnvConfig = Object.freeze({
  cmsUrl: 'https://cms-preprod.finnair.com',
  instantSearchUrl: 'https://api-preprod.finnair.com/d/fcom/instantsearch-preprod/current/api/instantsearch',
  offersUrl: 'https://api-preprod.finnair.com/d/fcom/offers-preprod/current/api/offerList',
  airBoundsUrl: 'https://api-preprod.finnair.com/d/fcom/offers-preprod/current/api/airBounds',
  airCalendarUrl: 'https://api-preprod.finnair.com/d/fcom/offers-preprod/current/api/airCalendar',
  locationsUrl: 'https://api-preprod.finnair.com/d/fcom/locations-preprod/current',
  recommendationUrl: 'https://api.finnair.com/c/recommendation/prod',
  timeGeoUrl: 'https://api.finnair.com/timegeo',
  bookingUrl: 'https://www-preprod.finnair.com',
  configUrl: 'https://api-preprod.finnair.com/d/fcom/config-preprod/current',
  amApiUrl: 'https://fpre.aurinkomatkat.fi/api/fcom-locations/v1',
  amDeeplinkUrl: 'https://fpre.aurinkomatkat.fi/matkahaku/finnair',
});

const prodConfig: EnvConfig = Object.freeze({
  cmsUrl: 'https://cms.finnair.com',
  instantSearchUrl: 'https://api.finnair.com/d/fcom/instantsearch-prod/current/api/instantsearch',
  offersUrl: 'https://api.finnair.com/d/fcom/offers-prod/current/api/offerList',
  airBoundsUrl: 'https://api.finnair.com/d/fcom/offers-prod/current/api/airBounds',
  airCalendarUrl: 'https://api.finnair.com/d/fcom/offers-prod/current/api/airCalendar',
  locationsUrl: 'https://api.finnair.com/d/fcom/locations-prod/current',
  recommendationUrl: 'https://api.finnair.com/c/recommendation/prod',
  timeGeoUrl: 'https://api.finnair.com/timegeo',
  bookingUrl: 'https://www.finnair.com',
  configUrl: 'https://api.finnair.com/d/fcom/config-prod/current',
  amApiUrl: 'https://www.aurinkomatkat.fi/api/fcom-locations/v1',
  amDeeplinkUrl: 'https://www.aurinkomatkat.fi/matkahaku/finnair',
});

export const getConfig = (env: Environment | EnvConfig): EnvConfig => {
  if (isObject(env)) {
    return env;
  }
  if (env === Environment.TEST) {
    return testConfig;
  }
  if (env === Environment.PREPROD) {
    return preprodConfig;
  }
  return prodConfig;
};
